<template>
  <a-row :gutter="[24, 0]" type="flex">
    <a-col
      class="border-separated"
      :xs="24"
      :sm="12"
      :md="24"
      v-for="(portal, index) in portale"
      :key="index"
    >
      <div class="direction-item">
        <div class="direction-item__thumbnail">
          <a-skeleton
            active
            class="thumbnail-skeleton"
            :loading="loading"
            :paragraph="false"
            :title="false"
          >
            <img :src="getPhoto(portal)" alt="" />
          </a-skeleton>
        </div>
        <div class="direction-item__desc">
          <div class="direction-item__header">
            <a-skeleton :loading="loading" active>
              <h3 class="c-blue-dark font-22 mb-4">
                {{ portal.maindata.name }}
              </h3>
              <div class="font-14 gray-30 text-truncate">
                <span class="svg-icon mr-6" aria-hidden="true">
                  <svg
                    class="svg-icon__svg"
                    width="12"
                    height="12"
                    focusable="false"
                  >
                    <use
                      xlink:href="/img/static/svg-sprites.svg#icon-globe"
                    ></use>
                  </svg>
                </span>
                <a class="gray-30" :href="portal.maindata.url">{{
                  portal.maindata.url
                }}</a>
              </div>
            </a-skeleton>
          </div>
          <div class="direction-item__content">
            <a-skeleton :loading="loading" active :title="false">
              <p class="mb-18">
                {{ portal.Opis }}
              </p>
              <div class="direction-item__highlights mb-6">
                <div class="hl-label">
                  <span
                    class="svg-icon mr-2 c-green-default"
                    aria-hidden="true"
                  >
                    <svg
                      class="svg-icon__svg"
                      width="15"
                      height="15"
                      focusable="false"
                    >
                      <use
                        xlink:href="/img/static/svg-sprites.svg#icon-like"
                      ></use>
                    </svg>
                  </span>
                  Polecamy:
                </div>
                <div class="hl-list">
                  <span
                    v-for="(polecane, index) in portal.Polecamy"
                    :key="index"
                  >
                    <template v-if="polecane.url != ''">
                      <a :href="polecane.url" :title="polecane.name">{{
                        polecane.name
                      }}</a
                      ><span>, </span>
                    </template>
                    <template v-else>
                      {{ polecane.name }}<span>, </span>
                    </template>
                  </span>
                </div>
              </div>
              <div class="direction-item__highlights">
                <div class="hl-label">
                  <span
                    class="svg-icon mr-2 c-yellow-default"
                    aria-hidden="true"
                  >
                    <svg
                      class="svg-icon__svg"
                      width="18"
                      height="18"
                      focusable="false"
                    >
                      <use
                        xlink:href="/img/static/svg-sprites.svg#icon-star"
                      ></use>
                    </svg>
                  </span>
                  Atrakcje:
                </div>
                <div class="hl-list">
                  <span
                    v-for="(atrakcja, index) in portal.Atrakcje"
                    :key="index"
                  >
                    <template v-if="atrakcja.url != ''">
                      <a :href="atrakcja.url" :title="atrakcja.name">{{
                        atrakcja.name
                      }}</a
                      ><span>, </span>
                    </template>
                    <template v-else>
                      {{ atrakcja.name }}<span>, </span>
                    </template>
                  </span>
                </div>
              </div>
            </a-skeleton>
          </div>
          <template>
            <a-skeleton
              active
              class="buttons-skeleton"
              :loading="loading"
              :paragraph="{ rows: 3 }"
              :title="false"
            >
              <T1DirectionGroupItemFooter
                :offersUrl="getOffersUrl(portal)"
                :geoUrl="getGeoUrl(portal)"
                :regionAbbr="getRegionAbbr(portal)"
              />
            </a-skeleton>
          </template>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import T1DirectionGroupItemFooter from "./T1DirectionGroupItemFooter";
import * as CONFIG from "../config.js";

export default {
  props: {
    portale: [Array, Object],
    grupy: [Array, Object],
    loading: Boolean
  },
  methods: {
    getPhoto(oferta) {
      return (
        "https://www-old.travelone.pl" +
        "/photo/imgs/portale-turystyczne/photo/" +
        oferta.maindata.photo
      );
    },
    getOffersUrl(oferta) {
      return oferta.maindata.url + oferta.maindata.urlof;
    },
    getGeoUrl(oferta) {
      return oferta.maindata.url + oferta.maindata.urlgeo;
    },
    getRegionAbbr(oferta) {
      let photoName = oferta.maindata.photo;
      let extractAbbr = photoName.slice(0, 2).toLowerCase();
      return extractAbbr;
    }
  },
  components: {
    T1DirectionGroupItemFooter
  }
};
</script>

<style lang="scss" scoped>
.direction-item {
  padding-bottom: 42px;

  @media (min-width: $screen-xs) and (max-width: $screen-xs-max) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  @media (min-width: $screen-sm) {
    display: flex;
    padding-bottom: 26px;
  }

  &__thumbnail {
    border-radius: 3px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: 12px;
    overflow: hidden;
    position: relative;
    height: 180px;
    width: 100%;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      align-items: flex-start;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
    }

    @media (min-width: $screen-sm) {
      margin-bottom: 0;
      margin-right: 16px;
      height: 178px;
      width: 28vw;
    }

    @media (min-width: $screen-md) {
      margin-right: 24px;
      height: 240px;
      width: 350px;
    }
  }

  &__header {
    margin-bottom: 12px;
  }

  &__desc {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: $screen-xs) and (max-width: $screen-xs-max) {
      height: 100%;
    }

    @media (min-width: $screen-md) {
      padding-bottom: 6px;
    }
  }

  &__content {
    margin-bottom: 24px;

    .svg-icon {
      text-align: center;
      width: 18px;
    }
  }

  &__highlights {
    @media (min-width: $screen-md) {
      display: flex;
    }

    .hl-label {
      @include font-m();
      display: inline-block;
      flex: 0 0 110px;
    }

    .hl-list {
      > span:last-child > span {
        display: none;
      }

      a {
        color: $text-color-default;
        text-decoration: underline;

        &:hover,
        &:focus {
          color: $blue-light;
        }
      }
    }
  }
}

.border-separated:not(:last-of-type) .direction-item {
  @media (min-width: $screen-sm) {
    border-bottom: 1px solid $gray-10;
    margin-bottom: 32px;
  }
}

::v-deep {
  .ant-skeleton-title {
    margin-top: 4px;
  }

  .ant-skeleton-content .ant-skeleton-paragraph > li + li {
    margin-top: 12px;
  }
}

.thumbnail-skeleton {
  @include skeleton-loading();
  height: 100%;
}

.buttons-skeleton {
  ::v-deep .ant-skeleton-content .ant-skeleton-paragraph {
    display: flex;
    margin-bottom: 0;

    @media (max-width: $screen-xs-max) {
      > li:not(:first-of-type) {
        display: none !important;
      }
    }

    > li,
    > li + li {
      height: 36px;
      margin-right: 12px;
      margin-top: 0;
      width: 140px !important;
    }
  }
}
</style>

<style lang="scss">
.ant-popover-inner-content {
  padding: 12px;
}
</style>
